import ApplicationBrand from 'components/common/ApplicationBrand'
import Img from 'components/common/Img'
import PadlockIcon from '../../../../../static/images/padlock-icon.svg'

import './style.styl'

const FormFooter = ({ partnerLogo, footerInfos = [] }) => {
  return (
    <footer className="form-footer">
      <div className="form-footer__container">
        {footerInfos?.map(({ key, infos }) => (
          <div
            key={key}
            className="form-footer__infos"
            dangerouslySetInnerHTML={{ __html: infos }}
          />
        ))}
        <div className="form-footer__content">
          <div className="form-footer__content__logos">
            <div className="form-footer__content__logos__application">
              <ApplicationBrand />
            </div>
            <div className="form-footer__content__logos__partner">
              <p>em parceria com</p>
              <Img alt="Logo do parceiro" src={partnerLogo} />
            </div>
          </div>
          <div className="form-footer__content__warning">
            <PadlockIcon />
            <p>Seus dados estão protegidos</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FormFooter
